module.exports = __webpack_public_path__ + "img/icon_2.c517fb65.png";